module.exports = __webpack_public_path__ + "img/highlight-banner.930adb07.png";